import { FormBase } from "../form-base";

export class TextBox extends FormBase<string> {
    controlType = 'textbox';
    type: string;

    constructor(options: Record<string, any> = {}) {
        super(options);
        this.type = options['type'] || '';
      }
}
